import { Nullable } from 'typescript-nullable';
import Partner from './partner';
import SlotName from '../common/slot-name';
import ScreenSize from '../common/screen-size';
import DeviceType from '../common/device-type';
import PageType from '../common/page-type';

export default class Amx extends Partner {
    readonly bidder = 'amx';
    readonly tagId = 'aPemU8ryR';
    mapping = {
        [PageType.ResultsPage]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.integratedMpu]: 'desktop_srp_middle1',
                    [SlotName.rSkyT]: 'desktop_srp_topright',
                    [SlotName.rSkyT2]: 'desktop_srp_topright2',
                    [SlotName.tBanner]: 'desktop_srp_top_new',
                    [SlotName.rSkyB]: 'desktop_srp_bottomright',
                    [SlotName.rSkyB2]: 'desktop_srp_bottomright2',
                    [SlotName.integratedListing]: 'desktop_srp_middle2',
                },
                [ScreenSize.XL]: {
                    [SlotName.integratedMpu]: 'desktop_srp_middle1',
                    [SlotName.rSkyT]: 'desktop_srp_topright',
                    [SlotName.rSkyT2]: 'desktop_srp_topright2',
                    [SlotName.tBanner]: 'desktop_srp_top_new',
                    [SlotName.rSkyB]: 'desktop_srp_bottomright',
                    [SlotName.rSkyB2]: 'desktop_srp_bottomright2',
                    [SlotName.integratedListing]: 'desktop_srp_middle2',
                },
                [ScreenSize.L]: {
                    [SlotName.integratedMpu]: 'desktop_srp_middle1',
                    [SlotName.tBanner]: 'desktop_srp_top_new',
                    [SlotName.integratedListing]: 'desktop_srp_middle2',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.L]: {
                    [SlotName.integratedMpu]: 'tablet_srp_middle1',
                    [SlotName.tBanner]: 'tablet_srp_top',
                    [SlotName.integratedListing]: 'Tablet_srp_middle2',
                },
                [ScreenSize.M]: {
                    [SlotName.integratedMpu]: 'tablet_srp_middle1',
                    [SlotName.tBanner]: 'tablet_srp_top',
                    [SlotName.integratedListing]: 'tablet_srp_middle2',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.integratedMpu]: 'mobile_srp_middle1',
                    [SlotName.integratedListing]: 'mobile_srp_middle2',
                    [SlotName.floatingFooter]: 'mobile_srp_floating',
                },
                [ScreenSize.XS]: {
                    [SlotName.integratedMpu]: 'mobile_srp_middle1',
                    [SlotName.integratedListing]: 'mobile_srp_middle2',
                    [SlotName.floatingFooter]: 'mobile_srp_floating',
                },
            },
        },
        [PageType.VIP]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.vipBanner]: 'desktop_vip_top_new',
                    [SlotName.mpu]: 'desktop_vip_topright',
                    [SlotName.vipMiddleDesktop]: 'desktop_srp_topright',
                    [SlotName.galleryMPU]: 'desktop_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'desktop_vip_gallery',
                },
                [ScreenSize.XL]: {
                    [SlotName.vipBanner]: 'desktop_vip_top_new',
                    [SlotName.mpu]: 'desktop_vip_topright',
                    [SlotName.vipMiddleDesktop]: 'desktop_srp_topright',
                    [SlotName.galleryMPU]: 'desktop_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'desktop_vip_gallery',
                },
                [ScreenSize.L]: {
                    [SlotName.vipBanner]: 'desktop_vip_top_new',
                    [SlotName.mpu]: 'desktop_vip_topright',
                    [SlotName.galleryMPU]: 'desktop_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'desktop_vip_gallery',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.L]: {
                    [SlotName.vipBanner]: 'tablet_vip_top_new',
                    [SlotName.mpu]: 'tablet_vip_topright',
                    [SlotName.fBanner]: 'tablet_vip_bottom',
                    [SlotName.galleryMPU]: 'tablet_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'tablet_vip_gallery',
                },
                [ScreenSize.M]: {
                    [SlotName.mpu]: 'tablet_vip_topright',
                    [SlotName.fBanner]: 'tablet_vip_bottom',
                    [SlotName.galleryMPU]: 'tablet_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'tablet_vip_gallery',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.floatingFooter]: 'mobile_vip_floating',
                    [SlotName.vipMiddleMobile]: 'mobile_vip_bottom',
                    [SlotName.galleryMPU]: 'mobile_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'mobile_vip_gallery',
                },
                [ScreenSize.XS]: {
                    [SlotName.floatingFooter]: 'mobile_vip_floating',
                    [SlotName.vipMiddleMobile]: 'mobile_vip_bottom',
                    [SlotName.galleryMPU]: 'mobile_vip_galleryMPU',
                    [SlotName.galleryBanner]: 'mobile_vip_gallery',
                },
            },
        },
        [PageType.MyMessages]: {
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.McFloatingFooter]: 'mobile_mc_floating',
                },
                [ScreenSize.XS]: {
                    [SlotName.McFloatingFooter]: 'mobile_mc_floating',
                },
            },
        },
        [PageType.Homepage]: {
            [DeviceType.desktop]: {
                [ScreenSize.XXL]: {
                    [SlotName.homeSideAd]: 'desktop_hp_topright',
                },
                [ScreenSize.XL]: {
                    [SlotName.homeSideAd]: 'desktop_hp_topright',
                },
                [ScreenSize.L]: {
                    [SlotName.homeSideAd]: 'desktop_hp_topright',
                },
            },
            [DeviceType.tablet]: {
                [ScreenSize.M]: {
                    [SlotName.homeSideAd]: 'tablet_hp_topright',
                },
            },
            [DeviceType.mobile]: {
                [ScreenSize.S]: {
                    [SlotName.homeBanner]: 'mobile_hp_topright',
                },
                [ScreenSize.XS]: {
                    [SlotName.homeBanner]: 'mobile_hp_topright',
                },
            },
        },
    };

    toObject() {
        if (Nullable.isNone(this.getPlacement())) {
            return undefined;
        }

        return {
            bidder: this.bidder,
            params: {
                tagId: this.tagId,
                adUnitId: this.getPlacement(),
            },
        };
    }
}
